import { useState } from "react";
import { eventCards, eventFilters } from "@/mocks/home";
import Reveal from "@/components/feature/Reveal";

export default function EventGrid() {
  const [activeFilter, setActiveFilter] = useState("全部");

  const visibleCards = activeFilter === "全部" ? eventCards : eventCards.filter((card) => card.category === activeFilter);

  return (
    <section id="events" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <p className="font-label text-xs tracking-[0.3em] text-primary-600">FULL COLLECTION</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">灵灵黑料全盘点合集</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              把散落各处的零碎信息按阶段重新拼回完整拼图。大卡看主线，小卡补细节，每条都标了对应的时间区间。
            </p>
          </div>
          <span className="font-label text-sm text-foreground-500">
            当前显示 <span className="font-heading text-lg font-bold text-primary-600">{visibleCards.length}</span> 篇整理
          </span>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-50 p-1 md:mt-8 md:inline-flex">
          {eventFilters.map((filter) => (
            <button
              key={filter}
              type="button"
              onClick={() => setActiveFilter(filter)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 font-label text-sm transition-colors ${
                activeFilter === filter
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 md:mt-8 md:gap-6">
          {visibleCards.map((card, index) => {
            const isFeatured = card.featured && index === 0;
            return (
              <Reveal
                key={card.id}
                delay={index * 60}
                className={isFeatured ? "sm:col-span-2 lg:col-span-2 lg:row-span-2" : ""}
              >
                <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-300">
                  <div className={`relative w-full overflow-hidden ${isFeatured ? "h-56 lg:h-[330px]" : "h-44"}`}>
                    <img
                      src={card.image}
                      alt={`${card.title} - 灵灵黑料事件汇总`}
                      title={`${card.tag} ｜ 灵灵黑料时间线`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 font-label text-[11px] text-primary-700">
                      {card.category}
                    </span>
                  </div>

                  <div className={`flex flex-1 flex-col p-4 md:p-5 ${isFeatured ? "lg:p-7" : ""}`}>
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-xs text-secondary-900">
                        {card.tag}
                      </span>
                      <span className="font-label text-xs text-foreground-500">{card.date}</span>
                    </div>
                    <h3
                      className={`mt-3 font-heading font-bold leading-snug text-foreground-950 ${
                        isFeatured ? "text-lg md:text-2xl" : "text-base md:text-lg"
                      }`}
                    >
                      {card.title}
                    </h3>
                    <p className={`mt-2 flex-1 leading-relaxed text-foreground-600 ${isFeatured ? "text-sm md:text-base" : "text-sm"}`}>
                      {card.summary}
                    </p>
                    <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                      <span className="font-label text-xs text-foreground-500">阅读约 {card.readTime}</span>
                      <span className="flex cursor-pointer items-center gap-1 font-label text-xs font-medium text-primary-600">
                        查看整理
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}